import { toolIsManuallyGraded } from '@macmillan-learning/gradebook-shared';
import PropTypes from 'prop-types';

import MLIcon from '../MLIcon/MLIcon';
import s from './UngradedIcon.module.css';

const UngradedIcon = ({ status, studentGrade, tool, subtype }) => {
  const assignmentStatus = status.toLocaleLowerCase() || '';
  // We override the studentGrade to be null when trying to hide the grade,
  // but still want to have an accurate status for ISG metrics
  if (assignmentStatus === 'completed' && studentGrade !== null) {
    return (
      <span role="img" aria-label="Student completed">
        <MLIcon type="check" className={s.completed} />
      </span>
    );
  } else if (
    assignmentStatus === 'missed' &&
    !toolIsManuallyGraded(tool, subtype)
  ) {
    return (
      <span role="img" aria-label="Student did not complete">
        <MLIcon type="x" className={s.missed} />
      </span>
    );
  } else if (assignmentStatus === 'unassigned') {
    // Should only occur in instructor gradebook
    return '-';
  }
  return '--';
};

UngradedIcon.propTypes = {
  status: PropTypes.string,
  studentGrade: PropTypes.string,
  tool: PropTypes.string,
  subtype: PropTypes.string,
};

export default UngradedIcon;
